"use client";

import React, { useState } from "react";
import { Alert, Button } from "@akashnetwork/ui/components";
import { AddressElement, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
interface PaymentMethodFormProps {
  onSuccess: () => void;
  onReady?: React.ComponentProps<typeof PaymentElement>["onReady"];
  buttonText?: string;
  processingText?: string;
  className?: string;
}
export const PaymentMethodForm: React.FC<PaymentMethodFormProps> = ({
  onSuccess,
  onReady,
  buttonText = "Add Card",
  processingText = "Processing...",
  className = ""
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setError(null);
    setIsProcessing(true);
    try {
      const result = await stripe.confirmSetup({
        elements,
        redirect: "if_required"
      });
      if (result.error) {
        setError(result.error.message || "An error occurred while processing your payment method.");
        return;
      }
      if (result.setupIntent?.status === "succeeded") {
        onSuccess();
      }
    } catch {
      setError("An unexpected error occurred.");
    } finally {
      setIsProcessing(false);
    }
  };
  return <form className={`space-y-6 ${className}`} onSubmit={handleSubmit} data-sentry-component="PaymentMethodForm" data-sentry-source-file="PaymentMethodForm.tsx">
      {/* Billing Address Section */}
      <div className="space-y-4">
        <h3 className="text-left text-sm text-muted-foreground">Billing Address</h3>
        <AddressElement options={{
        mode: "billing"
      }} data-sentry-element="AddressElement" data-sentry-source-file="PaymentMethodForm.tsx" />
      </div>

      {/* Payment Element */}
      <div className="space-y-2">
        <h3 className="text-left text-sm text-muted-foreground">Card Information</h3>
        <PaymentElement options={{
        layout: "tabs"
      }} onReady={onReady} data-sentry-element="PaymentElement" data-sentry-source-file="PaymentMethodForm.tsx" />
      </div>

      {error && <Alert className="mt-4" variant="destructive">
          {error}
        </Alert>}

      <Button type="submit" className="w-full" disabled={isProcessing} data-sentry-element="Button" data-sentry-source-file="PaymentMethodForm.tsx">
        {isProcessing ? processingText : buttonText}
      </Button>
    </form>;
};